import { transport, useTransportQuery } from "@/transport"

/**
 * Simulation output ids linked to any of `projectIds`, deduplicated in the
 * order the projects list them (oldest link first). Projects the overview no
 * longer returns, such as deleted ones, contribute nothing.
 */
export function useHumanReviewProjectsLinkedSimulationIdsTransport({
  projectIds,
  enabled = true,
}: {
  projectIds: string[]
  enabled?: boolean
}) {
  return useTransportQuery({
    operation: transport.operations.getReviewOverview,
    version: 2,
    request: {
      project_ids: projectIds,
      include_linked_simulation_ids: true,
      include_simulation_completions: false,
      include_simulation_metadata: false,
    },
    options: {
      enabled: enabled && projectIds.length > 0,
      select: (data) => {
        const requested = new Set(projectIds)
        const linkedIds = new Set<string>()
        for (const project of data.projects) {
          if (!requested.has(project.ulid)) {
            continue
          }
          for (const simulationOutputId of project.linked_simulation_ids) {
            linkedIds.add(simulationOutputId)
          }
        }
        return Array.from(linkedIds)
      },
    },
  })
}
